<template>
    <div class='copy'>
        <div class='header'>
            <span>抄送我</span>
            <div @click='changeStatu' v-if='openWxMsgRemid=="Y"'>关闭提醒</div>
            <div @click='changeStatu' v-if='openWxMsgRemid=="N"' class='div'>开启提醒</div>
        </div>
        <div class='check'>
            <van-checkbox v-model="checked" checked-color="#ee0a24" shape="square" icon-size=".15rem" label-disabled @change="pageNo=1;getCopytList()">仅未读/未批阅</van-checkbox>
        </div>
        <div class='tips' v-infinite-scroll="load" infinite-scroll-distance='20' infinite-scroll-delay='500'>
            <div class='item item-first'  v-for='item in copytList'  @click="$root.gotoDetail(item)">
                <div class='user-submit'>{{item.initiatorName}}提交的{{item.itemName}}<span v-if='item.isAwait == "Y"'></span></div>
                <div class='project-name'>{{item.bizItemName}}</div>
                <div class='submit-time'>
                    <span class='status' v-if='item.processProgress == "AUDIT_WAIT"'>审批中</span>
                    <span class='status agree' v-if='item.processProgress == "AUDIT_OK"'>审批通过</span>
                    <span class='status disagree' v-if='item.processProgress == "AUDIT_REJECTED"'>审批不通过</span>
                    <span class='status disagree' v-if='!item.processProgress'></span>
                    <span class='time'>{{item.initiateTime}}</span>
                </div>
            </div>
        </div>
        <Nav :navIndex='1' ref='nav'></Nav>
    </div>
</template>
<script>
import * as Urls from '../../helper/Urls';
import * as VueHelper from '../../helper/VueHelper';
import MenuUtils from '@/utils/MenuUtils'
import allMenu from '../../menu/allMenu';
import commonMenu from '../../menu/menu';
import moment from 'moment'
import Nav from './appNav'
export default {
    data(){
        return{
            checked:true,
            pageNo:1,
            pageSize:10,
            pageCount:0,
            copytList:[],
            openWxMsgRemid:'',
        }
    },
    created(){
        let userInfo = JSON.parse( sessionStorage.getItem('user'));
        this.openWxMsgRemid = userInfo&&userInfo.openWxMsgRemid;
        this.getCopytList()
    },
    methods:{
        changeStatu(){
            let inst = this;
            let userInfo = JSON.parse( sessionStorage.getItem('user'));
            let url = Urls.message_open_close;
            let params = {userId:userInfo.userId};
            this.$root.doGet(url,params,function(server_data){
                // 应用错误
                if(server_data.error){
                    Toast(server_data.error);
                    return;
                }
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid;
                userInfo.openWxMsgRemid = inst.openWxMsgRemid
                sessionStorage.setItem('user',JSON.stringify(userInfo))
            })
        },
        GetUrlParame(parameName) {
            var parames = window.location.search;
            if (parames.indexOf(parameName) > -1) {
                var parameValue = "";
                parameValue = parames.substring(
                    parames.indexOf(parameName),
                    parames.length
                );
                if (parameValue.indexOf("&") > -1) {
                    parameValue = parameValue.substring(
                        0,
                        parameValue.indexOf("&")
                    );
                    parameValue = parameValue.replace(parameName + "=", "");
                    return parameValue;
                }
                return "";
            }
        },
        wxAutoLogin(){
            let inst = this;
            let url = Urls.wx_auto_login;
            let params = {
                wxCode:this.code,
            }
            this.$root.doPost(url,params,function(server_data){
                if(server_data.returnCode==30){
                    sessionStorage.setItem('wxOpenId',server_data.data.wxOpenId);
                    let str = window.location.href;
                    window.location.href = str.split('?')[0] + '#'+ '/appLogin'  
                    return
                }
                sessionStorage.setItem('user',JSON.stringify(server_data.data))
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid
                let role = server_data.data.roleValue;
                // console.log("role:"+role);
                // 获取前端的角色的菜单权限
                // let menu = allMenu[role] || [];
                // menu = menu.concat(commonMenu);
                let menu = commonMenu;
                //拼接后台提供的列表路由
                let roleMeun = server_data.data.roleMeun;
                let menuData = [];
                
                roleMeun.forEach((element,index) => {
                  if(!element.children.length && element.workBenchList.length){//菜单有一级
                      menuData.push({
                          path:'/p'+index,
                          component: "HomeView",
                          redirect: element.workBenchList[0].benchPath,
                          name: element.menuName,
                          parent:true,
                          children:[
                              {
                                  pageAddress:element.workBenchList[0].benchComponent,
                                  path:element.workBenchList[0].benchPath,
                                  name:element.menuName
                              }
                          ]
                      })
                  }else if(!element.children[0].children.length){//菜单有二级
                      let data = {
                          path:'/p'+index,
                          redirect: '',
                          component: "HomeView",
                          name: element.menuName,
                          icon: element.menuIcon,
                          parent:true,
                          children:[]
                      };
                       element.children.forEach((element2,index2) => {
                          if(!element2.workBenchList.length)return;
                          data.children.push({
                              pageAddress:element2.workBenchList[0].benchComponent,
                              path:element2.workBenchList[0].benchPath,
                              name:element2.menuName,
                              icon: element2.menuIcon,
                          })
                          if(index2 === 0){
                              data.redirect = element2.workBenchList[0].benchPath;
                          }
                       })
                       
                       menuData.push(data);

                  }else{//菜单有三级
                      let data = {
                          path:'/p'+index,
                          redirect: '',
                          component: "HomeView",
                          name: element.menuName,
                          icon: element.menuIcon,
                          parent:true,
                          children:[]
                      };
                      element.children.forEach((element2,index2) => {
                          let data2 = {
                              parent:true,
                              component:"Navigation",
                              path:"/home",
                              name:element2.menuName,
                              icon: element2.menuIcon,
                              children:[]
                          }
                          element2.children.forEach((element3,index3) => {
                              if(!element3.workBenchList.length)return;
                              data2.children.push({
                                  pageAddress:element3.workBenchList[0].benchComponent,
                                  path:element3.workBenchList[0].benchPath,
                                  name:element3.menuName,
                                  icon: element3.menuIcon,
                              })
                              if(index2 === 0 && index3 === 0){
                                  data.redirect = element3.workBenchList[0].benchPath;
                              }

                              //拼接三级内页
                              for(let i = 0 ;i < menu.length; i++){
                                  let obj = menu[i];
                                  if(obj.menuId == element.menuCode){
                                      for(let j = 0 ;j < obj.children.length; j++){
                                          let obj2 = obj.children[j];
                                          if(obj2.menuId == element2.menuCode){
                                              data2.children = data2.children.concat(obj2.children);
                                              break;
                                          }
                                      }
                                  }
                              }
                              // menu.forEach(obj => {
                              //     obj.children.forEach(obj2 => {
                              //         if(obj2.name == element2.menuName && obj.name == element.menuName){
                              //             data2.children = data2.children.concat(obj2.children);
                              //             break;

                              //         }
                              //     })
                              // })

                          })
                          data.children.push(data2);

                      })
                      menuData.push(data);
                  }

                })
                //设置登录之后第一个页面
                if(menuData.length){
                  menuData[0].path = '/';
                }
                //打印页面
                menu.forEach((element,index) => {
                  if(element.hidden && !element.redirect){
                    menuData = menuData.concat(element);
                  }
                })




                window.sessionStorage.setItem('userPre',JSON.stringify(menuData))
                let routes = [];
                MenuUtils(routes,menuData)  //  引入组件 和过滤component      
                // console.log("登录routes",routes);
                inst.$router.addRoutes(routes);
                // inst.$router.push('/appLogin/copy');//微信代办登录跳转到列表页面
                 
                sessionStorage.token = server_data.data.token;
                inst.getCopytList();
                inst.$refs.nav.getUnreadCount();
                inst.$refs.nav.getUnreadCopyCount();
                let str = window.location.href;
                window.location.href = str.split('?')[0] + '#'+ '/appLogin/copy'
            });
        },
        formatTime(data) {
            if(data){
                return moment(data).format("HH:mm");
            }else{
                return '';
            } 
        },
        load(){
            if(this.pageCount > this.pageNo){
                this.pageNo++;
                this.getCopytList();
            }
        },
        getCopytList(){
            let [isAwait, inst, url] = [this.checked?'Y':'', this, Urls.message_unreadCopyMsgPage,]
            let params  =  {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                isAwait:isAwait
            }
            this.$root.doPost(url,params,function(server_data){
                // 用户没有登录
                if(server_data.sessionExpire=='Y'){
                    var local = window.location.href // 获取页面url
                    var appid = 'wxc3eb167e153f976a' 
                    inst.code = inst.GetUrlParame("code") // 截取code
                    if (inst.code == null || inst.code === ''){
                        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
                    }else{
                        inst.wxAutoLogin()
                    }
                }
                let page = server_data.data;
                page.dataList.map((item)=>{
                    let pre = new Date(new Date().toLocaleDateString()).getTime()-1;
                    let old =  new Date(new Date().toLocaleDateString()).getTime()-1-24*60*60*1000;
                    let getTime = new Date(inst.$root.formatDay(item.initiateTime)).getTime();
                    if(getTime<old){
                        item.initiateTime = inst.$root.formatDay(item.initiateTime)
                    }else if(old < getTime && getTime < pre){
                        item.initiateTime = '昨天'
                    }else{
                        item.initiateTime = inst.formatTime(item.initiateTime)
                    }
                })
                if(inst.pageNo==1){
                    inst.copytList = page.dataList;
                    inst.pageCount = page.pageCount;
                }else{
                    inst.copytList = inst.copytList.concat(page.dataList)
                }
                inst.totalCount = page.totalCount
            });
        }
    },
    components:{
        Nav
    },
}
</script>
<style lang="scss" scoped>
.copy{
    height: calc(100vh);
    background:#eee;
    max-width: 750px;
    font-family: PingFang SC;
    .header{
        height:.48rem;
        background:#fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0 .15rem;
        span{
            font-size: 0.18rem;
            font-weight: bold;
            color: #000000;
        }
        div{
            font-size: 0.13rem;
            font-weight: 500;
            color: #EC1212;
            border:.01rem solid #EC1212;
            width: .68rem;
            height:.24rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: .04rem;
        }
        .div{
            color: #000;
            border:.01rem solid #bbb;
        }
    }
    .check{
        height:.55rem;
        display: flex;
        align-items: center;
        padding-left: .15rem;
    }
    .tips{
        padding:0 .15rem;
        padding-bottom: .15rem;
        height: calc(100vh - 2.01rem);;
        overflow: auto;
        -webkit-overflow-scrolling:touch;
        .item{
            height: .83rem;
            background:#fff;
            border-radius: .15rem;
            margin-top:.15rem;
            padding:.18rem .2rem .18rem .1rem;
            text-indent: .1rem;
            .user-submit{
                font-size: 0.18rem;
                font-weight: bold;
                color: #000000;
                height: .22rem;
                line-height: .22rem;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                position: relative;
                span{
                    display: block;
                    width: .05rem;
                    height: .05rem;
                    border-radius: 50%;
                    background:#EC1212;
                    position: absolute;
                    top:.08rem;
                    left: 0;
                }
            }
            .project-name{
                font-size: 0.14rem;
                height: .18rem;
                line-height: .18rem;
                color: #999999;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                margin:.12rem 0 .12rem;
            }
            .submit-time{
                display: flex;
                justify-content: space-between;
                justify-items: center;
                font-size: 0.14rem;
                .status{
                    color:#E96B0F;
                }
                .agree{
                    color:#0A7007
                }
                .disagree{
                    color:#EC1212
                }
                .time{
                    color:#999;
                }
            }
        }
        .item-first{
            &:first-child{
                margin-top:0;
            }
        }
    }
    .nav{
        height: .83rem;
        background:#fff;
        display: flex;
        justify-content: space-around;
        position: fixed;
        max-width: 750px;
        width: 100%;
        bottom: 0;
    }
}
</style>


// WEBPACK FOOTER //
// copy.vue?a1f3db14